import {
  recordAfterUpdate,
  recordAfterDeleted,
  addItemInRecordInOldRecord,
} from "./CommonFnNew";

const INIT_STATE = {
  allInventory: [],
  inventorySpinner: false,
  inventorySuccess: false,
  inventoryError: false,
  responseMessage: "",
  inventoryData: null,
  addItemModalVisible: false,
  editItemModalVisible: false,
  initialValues: null,
  assignWatchModalVisible: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case "InventoryLoading_START": {
      return {
        ...state,
        inventorySpinner: true,
      };
    }

    case "InventoryLoading_STOP": {
      return {
        ...state,
        inventorySpinner: false,
      };
    }

    case "getInventory_SUCCESS": {
      return {
        ...state,
        inventorySuccess: true,
        inventoryError: false,
        allInventory: action.payload.Record,
        responseMessage: action.payload.Record.message,
      };
    }

    case "getInventory_FAILURE": {
      return {
        ...state,
        inventorySuccess: false,
        inventoryError: true,
        responseMessage: action.payload.Record.message,
      };
    }

    case "AddInventory_SUCCESS": {
      const inventoryArray = addItemInRecordInOldRecord(
        state.allInventory,
        action.payload.Record
      );
      return {
        ...state,
        inventorySuccess: true,
        inventoryError: false,
        allInventory: inventoryArray,
        responseMessage: action.payload.Record.message,
      };
    }

    case "AddInventory_FAILURE": {
      return {
        ...state,
        inventorySuccess: false,
        inventoryError: true,
        responseMessage: action.payload.Record.message,
      };
    }

    case "EditInventory_SUCCESS": {
      const inventoryArray = recordAfterUpdate(
        state.allInventory,
        action.payload.Record
      );
      return {
        ...state,
        inventorySuccess: true,
        inventoryError: false,
        allInventory: inventoryArray,
        // responseMessage: action.payload.Record.message,
      };
    }

    case "EditInventory_FAILURE": {
      return {
        ...state,
        inventorySuccess: false,
        inventoryError: true,
        responseMessage: action.payload,
      };
    }

    case "DeleteInventory_SUCCESS": {
      const inventoryArray = recordAfterDeleted(
        state.allInventory,
        action.payload.Record
      );
      return {
        ...state,
        inventorySuccess: true,
        inventoryError: false,
        allInventory: inventoryArray,
        responseMessage: action.payload.Record.message,
      };
    }

    case "DeleteInventory_FAILURE": {
      return {
        ...state,
        inventorySuccess: false,
        inventoryError: true,
        responseMessage: action.payload.Record.message,
      };
    }

    case "Show_AddItem_Modal": {
      return {
        ...state,
        addItemModalVisible: true,
        initialValues: null,
      };
    }

    case "Hide_AddItem_Modal": {
      return {
        ...state,
        addItemModalVisible: false,
        initialValues: null,
      };
    }

    case "Show_EditItem_Modal": {
      return {
        ...state,
        editItemModalVisible: !state.editItemModalVisible,
        initialValues: action.payload,
      };
    }

    case "Hide_EditItem_Modal": {
      return {
        ...state,
        editItemModalVisible: false,
        initialValues: null,
      };
    }

    case "Show_AssignWatch_Modal": {
      return {
        ...state,
        assignWatchModalVisible: true,
        initialValues: action.payload,
      };
    }

    case "Hide_AssignWatch_Modal": {
      return {
        ...state,
        assignWatchModalVisible: false,
        initialValues: null,
      };
    }

    case "InventoryLoading_RESET": {
      return {
        ...state,
        inventorySpinner: false,
        inventorySuccess: false,
        inventoryError: false,
        responseMessage: "",
        inventoryData: null,
        addItemModalVisible: false,
        editItemModalVisible: false,
        initialValues: null,
        assignWatchModalVisible: false,
      };
    }

    default:
      return state;
  }
};
